import { createContext, useState } from 'react';
import { Widths } from '../utils/Enums/Common';

interface SideBarContextData {
    sideBarVissible: boolean;
    setSideBarVissible: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SideBarContext = createContext({} as SideBarContextData);

export const SideBarProvider: React.FC = ({ children }) => {
    const isVissible = window.innerWidth > Widths.smallScreen;
    const [sideBarVissible, setSideBarVissible] = useState(isVissible);

    return (
        <SideBarContext.Provider value={{ sideBarVissible, setSideBarVissible }}>{children}</SideBarContext.Provider>
    );
};
